<script setup>
import { BPagination } from 'bootstrap-vue-next';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { numberParam } from '~/common/QueryParams';

const props = defineProps({
  totalRows: {
    type: Number,
    required: true,
  },
  perPage: {
    type: Number,
    required: true,
  },
});

const currentPage = defineModel({ required: false, type: Number });

const router = useRouter();
const route = useRoute();

const onPageChange = (newPage) => {
  const query = route.query;
  router.push({ query: { ...query, page: newPage } });
};

onMounted(() => {
  currentPage.value = numberParam(1).parse(route.query.page);
});
</script>

<template>
  <BPagination
    v-if="props.totalRows > props.perPage"
    v-model="currentPage"
    :total-rows="props.totalRows"
    :per-page="props.perPage"
    align="center"
    first-number
    last-number
    @update:model-value="onPageChange($event)"
  />
</template>
